import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { usePortalScope } from "../context/PortalScopeContext";

const SourceModal = ({ onClose, addSource }) => {
  const [newSource, setNewSource] = useState("");
  const api_url = process.env.REACT_APP_API_URL;
  const { portalScope } = usePortalScope();

  const handleAddSource = () => {
    if (!newSource.trim()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter a source name!",
      });
      return;
    }

    const token = localStorage.getItem("token");

    axios
      .post(
        `${api_url}/api/source`,
        { SourceName: newSource, scope: portalScope },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Send token in headers
          },
        },
      )
      .then((response) => {
        if (response.status === 201) {
          const createdSource = response.data?.source;

          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Source added successfully.",
          }).then(() => {
            addSource(createdSource || { SourceName: newSource }); // Update parent state
            setNewSource(""); // Clear input
            onClose(); // Close modal
          });
        }
      })
      .catch((error) => {
        console.error("Error adding source:", error);

        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          Swal.fire({
            icon: "error",
            title: "Unauthorized",
            text: "You do not have permission to add a source.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Error adding source. Please try again.",
          });
        }
      });
  };

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="custom-modal-header">
          <h5 className="custom-modal-title">Add New Source</h5>
          <button className="btn-close" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* Modal Body */}
        <div className="custom-modal-body">
          <input
            type="text"
            className="form-control"
            placeholder="Enter new source"
            value={newSource}
            onChange={(e) => setNewSource(e.target.value)}
          />
        </div>

        {/* Modal Footer */}
        <div className="custom-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={handleAddSource}>
            Add Source
          </button>
        </div>
      </div>
    </div>
  );
};

export default SourceModal;
